const MAX_EDGE = 1600;
const JPEG_QUALITY = 0.82;

function hasImageExtension(name: string): boolean {
  return /\.(png|jpe?g|webp|gif|heic|heif|avif)$/i.test(name);
}

function jpegName(name: string): string {
  const base = name.replace(/\.[^.]+$/, "").trim() || "photo";
  return `${base}.jpg`;
}

/**
 * Shrink photos before upload so a phone screenshot does not choke the API.
 * Non-images pass through.
 */
export async function prepareChatUploadFile(file: File): Promise<File> {
  if (!file.type.startsWith("image/") && !hasImageExtension(file.name)) {
    return file;
  }
  if (file.size <= 350_000 && file.type === "image/jpeg") {
    return file;
  }
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      bitmap.close();
      return file;
    }
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY);
    });
    if (!blob || blob.size === 0) {
      return file;
    }
    return new File([blob], jpegName(file.name), { type: "image/jpeg" });
  } catch {
    return file;
  }
}
